export default __webpack_public_path__ + "static/media/Motoden.6363c809.png";